import Image from 'next/image';
import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from '../../../styles/HomeLanding/HomeLanding.module.css'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, FreeMode, Mousewheel, Navigation, Pagination } from 'swiper';
import { Button } from 'reactstrap';
import { IndiaVideoTestimonial } from '@/constants/common';
import Link from 'next/link';
import { getBlogsData } from '@/services/signUpServices';
import useLazyInView from '@/hooks/useLazyInView';

const NewsSection = () => {
    const [sectionRef, isInView] = useLazyInView();
    const hasFetchedRef = useRef(false);
    const [activeTab, setActiveTab] = useState('Blogs');
    const [blogsData, setBlogsData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const data = {
        Blogs: blogsData,
        caseStudies: [
            {
                img: '/assets/HomeLanding/Thumbnail-Heineken.webp',
                altTxt: 'Heineken',
                title: 'Know how 314 Heineken breweries in Nigeria gained automated business momentum!',
                desc: "QueueBuster was selected as the best solution to achieve Heineken's requirements. Within 314 Heineken-owned breweries in Nigeria, the system was implemented and changed how these breweries handled their billing and inventory management processes.",
                link: '/casestudy/heineken',
            },
            {
                img: '/assets/HomeLanding/Thumbnail-hul.webp',
                altTxt: 'HUL',
                title: "How QueueBuster Improved HUL's SKU Visibility by 100%",
                desc: 'QueueBuster POS was deployed over 4000+ sub-stockists to provide real-time SKU tracking right from distributors to sub-stockists to Kirana stores.',
                link: '/casestudy/hul',
            },
            {
                img: '/assets/HomeLanding/Thumbnail-IRCTC.webp',
                altTxt: 'IRCTC',
                title: 'How QueueBuster Transformed Train Catering Services for IRCTC',
                desc: 'QueueBuster collaborated with multiple tender awardees to integrate a full-fledged billing and inventory management solution for Pine Labs card-swiping machines.',
                link: '/casestudy/irctc',
            },
            {
                img: '/assets/HomeLanding/Thumbnail-Cococart.webp',
                altTxt: 'CocoCart',
                title: 'How QueueBuster POS Transformed One Store into 65',
                desc: 'QueueBuster turned out to be the perfect solution, as it is the only POS software in India that can serve both requirements.',
                link: '/casestudy/coco-cart',
            },
        ],
        videos: IndiaVideoTestimonial,
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const fetchBlogData = async () => {
        try {
            setIsLoading(true);
            const blogs = await getBlogsData();
            setBlogsData(blogs || []);
        } catch (error) {
            console.error('Error fetching blog data:', error);
            setBlogsData([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!isInView || hasFetchedRef.current) return;
        hasFetchedRef.current = true;
        fetchBlogData();
    }, [isInView]);

    return (
        <div ref={sectionRef} style={{ height: "50rem", margin: "8rem 0" }}>
            <div style={{
                backgroundColor: "#161747",
                position: 'relative',
                padding: '5rem',
                height: "35rem",
                width: '100%'
            }}>
                <div style={{ maxWidth: '1850px', margin: '0 auto' }}>
                    <div style={{ margin: '0rem 13rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2.5rem' }}>
                            <div style={{ display: 'flex', gap: "1rem" }}>

                                <h2 style={{ fontWeight: "600", fontSize: "2.8rem", fontFamily: "GilroyBold", color: "#fff" }}>Insights to <br /> <span >Grow Your Business</span></h2>

                            </div>
                            <div style={{ display: 'flex', gap: '1rem', padding: "1rem", backgroundColor: "white", borderRadius: "5rem", height: "6.5rem" }}>
                                <Button
                                    onClick={() => handleTabChange('Blogs')}
                                    style={{

                                        border: activeTab === 'Blogs' ? '2px solid #2a6ab4' : '1px solid #ccc',
                                        backgroundColor: activeTab === 'Blogs' ? '#2a6ab4' : '#fff',
                                        color: activeTab === 'Blogs' ? '#fff' : '#000',
                                        cursor: 'pointer',
                                        border: 'none',
                                        padding: "0rem 3rem",
                                        fontSize: "1.4rem",
                                        borderRadius: "2.5rem",
                                        fontFamily: "GilroyMedium"
                                    }}
                                >
                                    Blogs
                                </Button>
                                <Button
                                    onClick={() => handleTabChange('caseStudies')}
                                    style={{

                                        border: activeTab === 'caseStudies' ? '2px solid #2a6ab4' : '1px solid #ccc',
                                        backgroundColor: activeTab === 'caseStudies' ? '#2a6ab4' : '#fff',
                                        color: activeTab === 'caseStudies' ? '#fff' : '#000',
                                        cursor: 'pointer',
                                        border: "none",
                                        padding: "1rem 3rem",
                                        fontSize: "1.4rem",
                                        borderRadius: "4rem",
                                        fontFamily: "GilroyMedium"
                                    }}
                                >
                                    Case Studies
                                </Button>
                                <Button
                                    onClick={() => handleTabChange('videos')}
                                    style={{
                                        border: activeTab === 'videos' ? '2px solid #2a6ab4' : '1px solid #ccc',
                                        backgroundColor: activeTab === 'videos' ? '#2A6AB4' : '#fff',
                                        color: activeTab === 'videos' ? '#fff' : '#000',
                                        cursor: 'pointer',
                                        border: "none",
                                        padding: "1rem 3rem",
                                        fontSize: "1.5rem",
                                        borderRadius: "4rem",
                                        fontFamily: "GilroyMedium"
                                    }}
                                >
                                    Videos
                                </Button>
                            </div>
                        </div>
                        <div style={{ height: "20rem", }}>
                            {!isInView || (isLoading && activeTab === 'Blogs' && blogsData.length === 0) ? (
                                <div style={{ color: '#fff', fontFamily: 'GilroyMedium', fontSize: '1.4rem', paddingTop: '4rem' }}>
                                    Loading insights...
                                </div>
                            ) : (
                            <Swiper
                                className="custom-features-swiper blogSwiper"
                                spaceBetween={20}
                                slidesPerView={'auto'}
                                autoplay={{
                                    delay: 10000,
                                    disableOnInteraction: false,
                                }}
                                navigation={{
                                    prevEl: '.custom-prev-device',
                                    nextEl: '.custom-next-device',
                                }}
                                speed={1000}
                                pagination={{ clickable: true }}
                                modules={[Autoplay, Pagination, Mousewheel, FreeMode]}
                                freeMode={true}
                                mousewheel={{
                                    forceToAxis: true,
                                    invert: false,
                                    sensitivity: 1,
                                }}
                                grabCursor={true}
                                key={`${activeTab}-${data[activeTab]?.length || 0}`}
                            >
                                {data[activeTab]?.map((item, index) => (

                                    <SwiperSlide key={index} style={{ width: "30rem" }}>
                                        <Link style={{ color: "black" }} href={item.link} passHref target="_blank">
                                            <div
                                                style={{
                                                    borderRadius: '2.5rem',
                                                    padding: '1.5rem',
                                                    height: "35rem",
                                                    backgroundColor: '#fff',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {activeTab === 'videos' ? (
                                                    <div>
                                                        <iframe loading="lazy" width="100%" src={item?.link} frameBorder="0" allowFullScreen style={{ borderRadius: '1.5rem', height: '15rem' }}></iframe>
                                                        <h3 style={{ fontSize: '1.6rem', margin: '1rem 0', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.5', color: "black" }}>{item.title}</h3>
                                                        <p style={{ fontSize: '1.2rem', color: '#475467', lineHeight: '1.5', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.5', color: "black" }}>{item.text}</p>
                                                    </div>
                                                ) : (
                                                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                                        <div>
                                                            <div style={{ position: "relative", width: "100%", height: "17rem" }}>
                                                                <Image
                                                                    src={item.img}
                                                                    alt={item.altTxt}
                                                                    style={{
                                                                        objectFit: 'cover',
                                                                        borderRadius: '1.5rem',
                                                                        marginBottom: '1rem',
                                                                        width: '100%',
                                                                        height: "100%"
                                                                    }}
                                                                    fill
                                                                    loading="lazy"
                                                                />
                                                            </div>
                                                            <p style={{ fontSize: '1rem', margin: '1rem 0', fontFamily: "GilroyMedium", color: "black" }}>{item.date}</p>
                                                            <h3 style={{ fontSize: '1.6rem', marginBottom: '1rem', fontFamily: "GilroyMedium", display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.5', color: "black" }}>{item.title}</h3>
                                                            <p style={{ fontSize: '1.2rem', color: '#475467', lineHeight: '1.5', fontFamily: "GilroyMedium", display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', marginTop: 'auto' }}>{item.desc}</p>
                                                        </div>
                                                    </div>
                                                )}

                                            </div>

                                        </Link>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};



export default NewsSection
